import React, { useEffect, useRef } from 'react';
import classes from './ResourceCardPanel.module.scss';
import ResourceProperty from '@/components/Resources/ResourceProperty/ResourceProperty';
import ResourceTag from '@/components/Resources/ResourceTag/ResourceTag';
import t from '@/utils/Language/ResourceCard-translations';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { applyFilters } from '@/utils/filters';
import { resourceHelpers, searchHelpers } from '@/utils/helpers';
import { Col, Container, Row } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import SuggestEditPanel from './SuggestEditPanel';

const InfoPanel = (
  { resource, language, project, includeSuggestEdits = true, includeFilterNote = true, includeTagList = true, includeDescription = true },
  ...props
) => {
  const listedProperties = resourceHelpers.listedProperties(resource.properties, searchHelpers);
  const suggestEditPanelClassName = {
    tagIcon: classes.tagIcon
  };
  const infoRef = useRef(null);

  useEffect(() => {
    //TODO: Need to fix for other projects as well
    if (project === 'allhome') {
      window.scrollTo({ top: infoRef.current.offsetTop - 70, behavior: 'smooth' });
    }
  }, [resource]);

  return (
    <Container className={classes.resourceCardPanel} ref={infoRef}>
      {includeDescription && (
        <Row className="mb-4">
          <Col xs={12}>
            <h2 className={classes.title}>
              <FontAwesomeIcon icon={[`fas`, `info-circle`]} className={classes.titleIcon} /> Info
            </h2>
            <p>{applyFilters(['linkify', 'paragrapherize'], resource.description)}</p>
          </Col>
        </Row>
      )}

      {resource.resource_type === 'Opportunity' && (
        <>
          {includeTagList && (
            <Row>
              <Col xs={12} className={classes.inlineList}>
                {resource.tags?.length && (
                  <ul className={classes.tagList}>
                    {resource.tags.map((tag, index) => (
                      <li>
                        <ResourceTag key={index} tag={tag} />
                      </li>
                    ))}
                  </ul>
                )}
              </Col>
            </Row>
          )}

          <Row>
            <Col xs={12} className={classes.inlineList}>
              {Object.keys(listedProperties).length && (
                <Row>
                  {Object.keys(listedProperties).map((property, index) => {
                    return (
                      <Col xs={12} md={6} lg={4} key={index} className={classes.eligCol}>
                        {property == 'eligibility-requirements' && (
                          <>
                            <FontAwesomeIcon icon="fa-solid fa-clipboard-check" className={classes.eligIcon} />
                            <ResourceProperty name={property} value={listedProperties[property]} className={classes.eligProp} />
                          </>
                        )}
                        {property != 'eligibility-requirements' && <ResourceProperty name={property} value={listedProperties[property]} />}
                      </Col>
                    );
                  })}
                </Row>
              )}
            </Col>
          </Row>
        </>
      )}
      {project !== 'allhome' && (
        <>
          {includeFilterNote && (
            <Row>
              <Col xs={12} className={classes.filterLinkContainer}>
                <Alert variant="warning" className={classes.alert}>
                  {t('Have needs use filters')}
                </Alert>
              </Col>
            </Row>
          )}
          {includeSuggestEdits && (
            <Row>
              <Col xs={12} className={classes.suggestEdit}>
                <SuggestEditPanel resource={resource} additionalClass={suggestEditPanelClassName} project="locationA" />
              </Col>
            </Row>
          )}
        </>
      )}
    </Container>
  );
};

export default InfoPanel;
